module.exports = __webpack_public_path__ + "6267.bd726e58a02e69774d7e2ecb130fe054.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6267.png
// module id = 93
// module chunks = 0